import Vue from 'vue';
import Router from 'vue-router';

import TicketList from '@/pages/TicketList';
import OperatingGuide from '@/pages/OperatingGuide';

Vue.use(Router);

export default new Router({
    mode: process.env.ROUTER_MODE,
    routes: [
      {
        path: '/v1/ucticketList',
        name: 'TiketList',
        component: TicketList
      },
      {
        path: '/v1/ucticketList/operatingGuide',
        name: 'OperatingGuide',
        component: OperatingGuide
      }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js